import { render, staticRenderFns } from "./BankSetting.vue?vue&type=template&id=426f7634"
import script from "./BankSetting.vue?vue&type=script&lang=js"
export * from "./BankSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports